import React, { HTMLAttributes } from 'react'
import { csx, cx } from '@vtex/admin-ui'

export type ProductImageProps = {
  src?: string
  alt: string
  onLoadImageError?: () => void
} & HTMLAttributes<HTMLDivElement>

export const ProductImage = ({
  src,
  alt,
  className = '',
  onLoadImageError,
  ...props
}: ProductImageProps) => (
  <div className={cx(csx({ width: '100%' }), className)} {...props}>
    <div
      className={csx({
        position: 'relative',
        paddingBottom: '100%',
      })}
    >
      {src && (
        <img
          src={src}
          alt={alt}
          onError={onLoadImageError}
          className={csx({
            position: 'absolute',
            top: 0,
            left: 0,
            width: 'full',
            height: 'full',
            objectFit: 'contain',
          })}
        />
      )}
      <div
        className={csx({
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.03)',
          borderRadius: '4px',
        })}
      />
    </div>
  </div>
)
